
import { computed, defineComponent, reactive } from 'vue';
import { IOptionString } from '@/core/models/AntDesign/IOption';
import ServicoNotaFiscal from '@/servicos/Fiscal/ServicoNotaFiscal';

export default defineComponent({
  name: 'SelecionarMarcadorNotaFiscal',
  props: {
    marcadoresSelecionados: {
      type: Array as () => string[],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Digite para definir um marcador',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    classCss: {
      type: String,
      default: '',
    },
  },
  emits: ['update:marcadoresSelecionados', 'blur'],
  setup(props, { emit }) {
    let debounce = 0;
    const servicoNotaFiscal = new ServicoNotaFiscal();
    servicoNotaFiscal.requisicaoSistema();

    const state = reactive({
      listaMarcadores: [] as IOptionString[],
    });

    const computedMarcadoresSelecionados = computed({
      get: () => props.marcadoresSelecionados,
      set: (valor: string[]) => {
        emit('update:marcadoresSelecionados', valor);
      },
    });

    function blur() {
      emit('blur');
    }

    async function pesquisarMarcador(valorPesquisa: any) {
      state.listaMarcadores = [];
      clearTimeout(debounce);
      debounce = setTimeout(async () => {
        let marcadoresApi = [] as string[];
        marcadoresApi = await servicoNotaFiscal.consultarMarcadores(valorPesquisa);
        marcadoresApi.forEach((marcador) => {
          const optionMarcador:IOptionString = { value: marcador, label: marcador };
          state.listaMarcadores.push(optionMarcador);
        });
      }, 600);
    }

    return {
      props,
      state,
      pesquisarMarcador,
      computedMarcadoresSelecionados,
      blur,
    };
  },
});
